import { render } from "./uploadZBGZApproval.vue?vue&type=template&id=7cb50c1c&scoped=true"
import script from "./uploadZBGZApproval.vue?vue&type=script&lang=js"
export * from "./uploadZBGZApproval.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb50c1c"]])

export default __exports__